<template>
  <nly-content-wrapper>
    <nly-breadcrumb>
      
      <nly-breadcrumb-item text="Matérias" to="materias" />
      <nly-breadcrumb-item text="Aulas" to="aulas" />
      <nly-breadcrumb-item text="Estudos" active />
   
    </nly-breadcrumb>
    <nly-content>
      <div class="row">
        <div class="col-md-8">
            <div v-if="!caminho_video_youtube" class=" text-center">
                <h1>Selecione Um video ao lado </h1>
            </div>
          <div v-if="caminho_video_youtube" class="embed-responsive embed-responsive-16by9">
            <iframe
              class="embed-responsive-item"
              :src="caminho_video_youtube"
              allowfullscreen
            ></iframe>
          </div>
        </div>
        <div class="col-md-4">
          <div   v-for="(lista,index) in AllArquivos" :key="index" class="callout callout-danger row" >
            <div class="col-md-9 col-xs-9">
              <!-- <h5>Aula {{lista.id}}</h5> -->
              <p>{{lista.nome}}</p>
            </div>
            <div class="col-md-3 col-xs-3">
              <button @click="Abrir_video_youtube(lista)" v-if="lista.url" class="bt btn-primary">Visualizar</button>
               <button @click="Download(lista)"   v-if="!lista.url" class="bt btn-primary">Donwload</button>
            </div>
          </div>
        </div>
      </div>
    </nly-content>
  </nly-content-wrapper>
</template>

<script>
export default {
  data() {
    return {
      caminho_video_youtube: '',
      url_video_link: '',
      
    };
  },
  created() {
    //   this.Voltar()
  },
  computed: {
    AllArquivos() {
      return this.$store.state.estudos.Arquivos;
    }
  },
  methods: {
    Download(value){
        window.open('http://plataforma.ucpvirtual.com.br/testes/download_arquivos/'+value.arquivo_id, '_blank');
    },
   

    Abrir_video_youtube(caminho) {

      console.log(caminho.url.indexOf("youtu"));
      console.log(caminho.url.indexOf("vime"));

      this.url_video_link = caminho.url;
     

      const link = "https://www.youtube.com/embed/";
      const link2 = "https://player.vimeo.com/video/";

      var part = caminho.url.split("=");

      if (part[1]) {
        this.caminho_video_youtube = link + part[1]; //aqui vai o youtube
      } else {
        if (caminho.url.indexOf("you") >= 1) {
           part = caminho.url.split("/");
          this.caminho_video_youtube = link + part[3]; //aqui vai o youtube
        } else {
          var part2 = caminho.url.split("/");
          this.caminho_video_youtube = link2 + part2[3]; // aqui vai o vimeo
        }
      }

      //  console.log("https://player.vimeo.com/video/396964963");

      console.log("original " + caminho.url);
      console.log("modificado " + this.caminho_video_youtube);
    }
  }
};
</script>